export default __webpack_public_path__ + "static/media/Bg_2024_web.4d6811ba.png";